<template>
  <div id="header">
    <div class="wrap">
      <h1 class="logo">
        <a href="/">
          <h5 style="padding:10px 0;color:#333;">广州市金界电子设备有限公司</h5>
          <!-- <img src="../assets/logo.png" alt title="logo"> -->
        </a>
      </h1>
      <div class="center">
        <img src="../assets/tc.png" alt>
      </div>
    </div>
  </div>
</template>
<style scoped>
#header {
  width: 100%;
  height: 85px;
  background-color: #fff;
}
.wrap {
  width: 1000px;
  margin: 0 auto;
  padding-top: 10px;
  overflow: hidden;
  text-align: center;
}
.logo {
  /* display: inline-block; */
  /* margin: 0 20px; */
  float: left;
  /* border-right: 1px solid black; */
}
.center {
  /* display: inline-block; */
  /* margin: 0 20px; */
  float: left;
  padding-top: 26px;
  padding-left: 26px;
}
</style>

<script>
export default {
  name: "header",
  data() {
    return {};
  }
};
</script>




// WEBPACK FOOTER //
// src/components/header.vue